import Section from './_Section'
import { createMarkup } from '../../helpers/markup'
import { useEffect, useState } from 'react'
import { transformPaddingToTailwind } from '../../helpers/style'

function BasicContentWithColumns(props) {
  const componentPadding = transformPaddingToTailwind(props.componentPadding)
  const [spacing, setSpacing] = useState('100')
  const [columnClass, setColumnClass] = useState('grid-cols-1')
  const [alignmentClass, setAlignmentClass] = useState('')
  const [decorationClass, setDecorationClass] = useState('')
  const [decorationColour, setDecorationColour] = useState(null)

  const decorationWidth = props.decorationWidth ? `-${props.decorationWidth.replace('px', '')}` : ''

  useEffect(() => {
    let divideXBP = ''
    let divideYBP = ''
    let cols = ''
    switch (props.columnSpacing) {
      case '100':
        // with both decorators active the 100% width never needs the left border
        cols = 'grid-cols-1 *:!border-l-0'
        break
      case '50-50':
        cols = 'grid-cols-1 lg:grid-cols-2 [&>*:nth-child(3n+3)]:!border-l-0 lg:[&>*:nth-child(2)]:!border-t-0'
        divideXBP = 'lg:'
        break
      case '33-33-33':
        cols =
          'grid-cols-1 lg:grid-cols-3 [&>*:nth-child(4n+4)]:!border-l-0 lg:[&>*:nth-child(2)]:!border-t-0 lg:[&>*:nth-child(3)]:!border-t-0'
        divideXBP = 'lg:'
        break
      case '25-25-25-25':
        cols =
          'grid-cols-1 md:grid-cols-2 max-xl:[&>*:nth-child(3n+3)]:!border-l-0 xl:grid-cols-4 md:max-xl:[&>*:nth-child(2)]:!border-t-0'
        divideXBP = 'md:'
        divideYBP = 'max-xl:'
        break
      case '80-20':
        cols =
          'grid-cols-1 md:grid-cols-[6fr,_4fr] lg:grid-cols-[8fr,_2fr] [&>*:nth-child(3n+3)]:!border-l-0 md:[&>*:nth-child(2)]:!border-t-0'
        divideXBP = 'md:'
        break
      case '20-80':
        cols =
          'grid-cols-1 md:grid-cols-[4fr,_6fr] lg:grid-cols-[2fr,_8fr] [&>*:nth-child(3n+3)]:!border-l-0 md:[&>*:nth-child(2)]:!border-t-0'
        divideXBP = 'md:'
        break
      case '25-50-25':
        cols =
          'grid-cols-1 lg:grid-cols-[1fr,_2fr,_1fr] [&>*:nth-child(4n+4)]:!border-l-0 lg:[&>*:nth-child(2)]:!border-t-0 lg:[&>*:nth-child(3)]:!border-t-0 '
        divideXBP = 'lg:'
    }
    setColumnClass(cols)

    setDecorationColour(() => {
      if (props.decorationColour) {
        return `divide-${props.decorationColour}-500`
      }
      return ''
    })

    let alignment = ''
    switch (props.columnContentAlignment) {
      case 'Top':
        alignment = 'justify-start'
        break
      case 'Middle':
        alignment = 'justify-center'
        break
      case 'Bottom':
        alignment = 'justify-end'
    }
    setAlignmentClass(alignment)

    let deco = '*:p-4'
    switch (props.decoration) {
      case 'Vertical':
      deco = `${divideXBP}divide-x${decorationWidth} *:p-4`
      break
      case 'Horizontal':
        deco = `${divideYBP}divide-y${decorationWidth} *:p-4`
        break
      case 'Both':
        deco = `${divideXBP}divide-x${decorationWidth} *:p-4 ${divideYBP}divide-y${decorationWidth}`
    }
    setDecorationClass(deco)
  }, [])

  return (
    <Section type="basicContentWithColumns" outerClass={componentPadding} innerClass="px-7" {...props}>
      {props.contentColumnItems?.length > 0 && (
        // <div className={`column-wrapper grid *:px-6 *:my-6   ${decorationClass} ${columnClass} ${alignmentClass}`}>
        <div className={`column-wrapper grid items-stretch ${decorationColour} ${decorationClass} ${columnClass} `}>
          {props.contentColumnItems?.map((col) => {
            return (
              <div className={`column flex flex-col h-full ${alignmentClass}`} data-rte="true">
                <div dangerouslySetInnerHTML={createMarkup(col.content)} />
              </div>
            )
          })}
        </div>
      )}
    </Section>
  )
}

export default BasicContentWithColumns
